<form [formGroup]="form" class="mat-typography" *ngIf="form">
    <div *ngIf="form.invalid" class="form-error-banner">
        <mat-error *ngIf="form.get('RedirectAddress')?.hasError('required')">
            Redirect address is required when redirect is enabled.
        </mat-error>
        <mat-error *ngIf="form.get('RedirectAddress')?.hasError('email')">
            Redirect address must be a valid email address.
        </mat-error>
        <mat-error *ngIf="form.hasError('requireOneIncludeTarget')">
            At least one Include target (Users, Groups, or Domains) is required.
        </mat-error>
    </div>

    <mat-accordion multi>
        <!-- Settings -->
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <div class="items-center w-full flex justify-between">
                    <mat-panel-title class="font-bold"> Settings </mat-panel-title>
                    <div>
                        <sway-baseline-status
                            [hasError]="
                                errorsString.includes('Identity!') ||
                                errorsString.includes('Priority!') ||
                                errorsString.includes('Enable!') ||
                                errorsString.includes('Action!') ||
                                errorsString.includes('QuarantineTag!') ||
                                errorsString.includes('Redirect!') ||
                                errorsString.includes('RedirectAddress!')
                            "
                        >
                        </sway-baseline-status>
                    </div>
                </div>
            </mat-expansion-panel-header>

            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>Current Value</th>
                        <th>Desired Value</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <div class="flex-data">
                                Identity
                                <mat-icon matTooltip="The display name for this Safe Attachment policy.">info</mat-icon>
                            </div>
                        </td>
                        <td>{{ policy?.Identity || 'No policy' }}</td>
                        <td>
                            {{ formValue?.Identity }}
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('Identity!') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>

                    <tr>
                        <td>Status</td>
                        <td>{{ policy ? (policy?.Enable ? 'Enabled' : 'Disabled') : 'No policy' }}</td>
                        <td>
                            <mat-form-field appearance="fill">
                                <mat-select formControlName="Enable">
                                    <mat-option [value]="true">Enabled</mat-option>
                                    <mat-option [value]="false">Disabled</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('Enable!') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <div class="flex-data">
                                Safe Attachments unknown malware response
                                <mat-icon
                                    matTooltip="Monitor and Block actions might cause a significant delay in message delivery. Dynamic Delivery is only available for recipients with hosted mailboxes. For Block or Dynamic Delivery, messages with detected attachments are quarantined and can be released only by an admin."
                                    >info</mat-icon
                                >
                            </div>
                        </td>
                        <td>{{ policy ? (actionLabels[policy.Action] ?? policy.Action) : 'No policy' }}</td>
                        <td>
                            <mat-form-field appearance="fill">
                                <mat-select formControlName="Action">
                                    <mat-option [value]="'Allow'">
                                        Off - Attachments will not be scanned by Safe Attachments.
                                    </mat-option>

                                    <mat-option [value]="'Block'">
                                        Block - Block current and future messages and attachments with detected malware.
                                    </mat-option>

                                    <mat-option [value]="'DynamicDelivery'">
                                        Dynamic Delivery (Preview messages) - Immediately deliver the message without
                                        attachments. Reattach files after scanning is complete.
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('Action') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <div class="flex-data">
                                Quarantine Policy
                                <mat-icon
                                    matTooltip="Specifies the quarantine policy applied to messages quarantined by Safe Attachments."
                                    >info</mat-icon
                                >
                            </div>
                        </td>
                        <td>{{ policy ? policy.QuarantineTag : 'No policy' }}</td>
                        <td>
                            <mat-form-field appearance="fill">
                                <mat-select formControlName="QuarantineTag">
                                    <mat-option *ngFor="let qp of quarantinePolicies$ | async" [value]="qp.Name">
                                        {{ qp.Name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('QuarantineTag') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <div class="flex-data">
                                Redirect messages with detected attachments
                                <mat-icon matTooltip=" Enable redirect only supports the Monitor action. "
                                    >info</mat-icon
                                >
                            </div>
                        </td>
                        <td>{{ policy ? (policy?.Redirect ? 'Enabled' : 'Disabled') : 'No policy' }}</td>
                        <td>
                            <mat-form-field appearance="fill">
                                <mat-select formControlName="Redirect">
                                    <mat-option [value]="true">Enabled</mat-option>
                                    <mat-option [value]="false">Disabled</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('Redirect!') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>

                    <tr *ngIf="redirectEnabled">
                        <td>
                            <div class="flex-data">
                                Send messages that contain monitored attachments to the specified email address.
                            </div>
                        </td>
                        <td>{{ policy?.RedirectAddress }}</td>
                        <td>
                            <mat-form-field appearance="fill">
                                <input formControlName="RedirectAddress" matInput placeholder="admin@contoso.com" />
                                <mat-error *ngIf="form.get('RedirectAddress').errors?.required">
                                    Redirect address is required.
                                </mat-error>
                                <mat-error *ngIf="form.get('RedirectAddress').errors?.email">
                                    Please enter a valid email address.
                                </mat-error>
                            </mat-form-field>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('RedirectAddress') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <div class="flex-data">
                                Priority
                                <mat-icon
                                    matTooltip="The priority of the Safe Attachment rule. Lower number means higher priority. 0 is the highest priority."
                                    >info</mat-icon
                                >
                            </div>
                        </td>
                        <td>{{ policy?.Priority ?? '-' }}</td>
                        <td>
                            <mat-form-field appearance="fill">
                                <input
                                    [readonly]="true"
                                    formControlName="Priority"
                                    matInput
                                    type="number"
                                    min="0"
                                    placeholder="0"
                                />
                            </mat-form-field>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('Priority') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>
                </tbody>
            </table>
            <mat-error *ngIf="settingsError"> Please correct the validation errors in the Settings section. </mat-error>
        </mat-expansion-panel>

        <!-- Include Targets -->
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <div class="items-center w-full flex justify-between">
                    <mat-panel-title class="font-bold"> Include </mat-panel-title>
                    <div>
                        <sway-baseline-status
                            [hasError]="
                                errorsString.includes('SentTo!') ||
                                errorsString.includes('SentToMemberOf!') ||
                                errorsString.includes('RecipientDomainIs!')
                            "
                        >
                        </sway-baseline-status>
                    </div>
                </div>
            </mat-expansion-panel-header>
            <div *ngIf="includeTargetError">
                <mat-error >
                    At least one Include target (Users, Groups, or Domains) is required.
                </mat-error>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>Current Value</th>
                        <th>Desired Value</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <div class="flex-data">
                                Include Users
                                <mat-icon
                                    matTooltip="Apply this policy to messages sent to specific users (by email address)."
                                    >info</mat-icon
                                >
                            </div>
                        </td>
                        <td>
                            <div *ngIf="policy?.SentTo?.length > 0">
                                <div *ngFor="let item of policy.SentTo">{{ item }}</div>
                            </div>
                            <span *ngIf="!policy?.SentTo?.length">-</span>
                        </td>
                        <td>
                            <ng-select
                                formControlName="SentTo"
                                [items]="users$ | async"
                                [multiple]="true"
                                bindLabel="name"
                                bindValue="name"
                                [appendTo]="'body'"
                                placeholder="Include Users"
                            >
                            </ng-select>
                            <mat-error *ngIf="sentToErrors?.length > 0">
                                Invalid email(s): {{ sentToErrors.join(', ') }}
                            </mat-error>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('SentTo!') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <div class="flex-data">
                                Include Groups
                                <mat-icon matTooltip="Apply this policy to messages sent to members of specific groups."
                                    >info</mat-icon
                                >
                            </div>
                        </td>
                        <td>
                            <div *ngIf="policy?.SentToMemberOf?.length > 0">
                                <div *ngFor="let item of policy.SentToMemberOf">{{ item }}</div>
                            </div>
                            <span *ngIf="!policy?.SentToMemberOf?.length">-</span>
                        </td>
                        <td>
                            <ng-select
                                formControlName="SentToMemberOf"
                                [items]="groups$ | async"
                                [multiple]="true"
                                bindLabel="name"
                                bindValue="mail"
                                [appendTo]="'body'"
                                placeholder="Include Groups"
                            >
                            </ng-select>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('SentToMemberOf') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <div class="flex-data">
                                Include Domains
                                <mat-icon
                                    matTooltip="Apply this policy to messages sent to recipients in specific domains."
                                    >info</mat-icon
                                >
                            </div>
                        </td>
                        <td>
                            <div *ngIf="policy?.RecipientDomainIs?.length > 0">
                                <div *ngFor="let item of policy.RecipientDomainIs">{{ item }}</div>
                            </div>
                            <span *ngIf="!policy?.RecipientDomainIs?.length">-</span>
                        </td>
                        <td>
                            <ng-select
                                formControlName="RecipientDomainIs"
                                [items]="domains$ | async"
                                [multiple]="true"
                                bindLabel="name"
                                bindValue="name"
                                [appendTo]="'body'"
                                placeholder="Include Domains"
                            >
                            </ng-select>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('RecipientDomainIs') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>
                </tbody>
            </table>
        </mat-expansion-panel>

        <!-- Exclude Targets -->
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <div class="items-center w-full flex justify-between">
                    <mat-panel-title class="font-bold"> Exclude </mat-panel-title>
                    <div>
                        <sway-baseline-status
                            [hasError]="
                                errorsString.includes('ExceptIfSentTo!') ||
                                errorsString.includes('ExceptIfSentToMemberOf!') ||
                                errorsString.includes('ExceptIfRecipientDomainIs!')
                            "
                        >
                        </sway-baseline-status>
                    </div>
                </div>
            </mat-expansion-panel-header>

            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>Current Value</th>
                        <th>Desired Value</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <div class="flex-data">
                                Exclude Users
                                <mat-icon matTooltip="Exclude specific users from this policy.">info</mat-icon>
                            </div>
                        </td>
                        <td>
                            <div *ngIf="policy?.ExceptIfSentTo?.length > 0">
                                <div *ngFor="let item of policy.ExceptIfSentTo">{{ item }}</div>
                            </div>
                            <span *ngIf="!policy?.ExceptIfSentTo?.length">-</span>
                        </td>
                        <td>
                            <ng-select
                                formControlName="ExceptIfSentTo"
                                [items]="users$ | async"
                                [multiple]="true"
                                bindLabel="name"
                                bindValue="name"
                                [appendTo]="'body'"
                                placeholder="Exclude Users"
                            >
                            </ng-select>
                            <mat-error *ngIf="exceptIfSentToErrors?.length > 0">
                                Invalid email(s): {{ exceptIfSentToErrors.join(', ') }}
                            </mat-error>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('ExceptIfSentTo!') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <div class="flex-data">
                                Exclude Groups
                                <mat-icon matTooltip="Exclude members of specific groups from this policy."
                                    >info</mat-icon
                                >
                            </div>
                        </td>
                        <td>
                            <div *ngIf="policy?.ExceptIfSentToMemberOf?.length > 0">
                                <div *ngFor="let item of policy.ExceptIfSentToMemberOf">{{ item }}</div>
                            </div>
                            <span *ngIf="!policy?.ExceptIfSentToMemberOf?.length">-</span>
                        </td>
                        <td>
                            <ng-select
                                formControlName="ExceptIfSentToMemberOf"
                                [items]="groups$ | async"
                                [multiple]="true"
                                bindLabel="name"
                                bindValue="mail"
                                [appendTo]="'body'"
                                placeholder="Exclude Groups"
                            >
                            </ng-select>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('ExceptIfSentToMemberOf') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <div class="flex-data">
                                Exclude Domains
                                <mat-icon matTooltip="Exclude recipients in specific domains from this policy."
                                    >info</mat-icon
                                >
                            </div>
                        </td>
                        <td>
                            <div *ngIf="policy?.ExceptIfRecipientDomainIs?.length > 0">
                                <div *ngFor="let item of policy.ExceptIfRecipientDomainIs">{{ item }}</div>
                            </div>
                            <span *ngIf="!policy?.ExceptIfRecipientDomainIs?.length">-</span>
                        </td>
                        <td>
                            <ng-select
                                formControlName="ExceptIfRecipientDomainIs"
                                [items]="domains$ | async"
                                [multiple]="true"
                                bindLabel="name"
                                bindValue="name"
                                [appendTo]="'body'"
                                placeholder="Exclude Domains"
                            >
                            </ng-select>
                        </td>
                        <td>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('ExceptIfRecipientDomainIs') || !policy"
                            ></sway-baseline-status>
                        </td>
                    </tr>
                </tbody>
            </table>
            <mat-error *ngIf="excludeError">
                Invalid email(s) in Exclude Users: {{ exceptIfSentToErrors.join(', ') }}
            </mat-error>
        </mat-expansion-panel>
    </mat-accordion>
</form>
